import { renderWithNavCopilot as render } from 'quartz-core/client-with-copilot';
// I18n Configuration
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { initAppTranslations } from 'I18n/init/setup/AppInit';

// Import extra I18n data
import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// Redux
import { Provider as ReduxProvider } from 'react-redux';
import configureStore from './utils/configureStore';
import { startAppAndFetch } from './actions/AppActions';
import { fetchPreviewDomain } from './actions/PreviewActions';
import { getAuth } from './actions/AuthActions';
// Data fetching client
import { DataFetchingClientProvider, DataFetchingClient } from 'data-fetching-client';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from 'hubspot-apollo-client';

// Configure the router
import { BrowserRouter, Route } from 'react-router-dom';
import { getRootUrl } from './utils/urls';
import AppContainer from './containers/AppContainer';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import withReferenceResolvers from './hoc/withReferenceResolvers';
import MessageBusProvider from 'crm-message-bus/MessageBusProvider';
import { Application } from 'foundations-components/components/Application';
import { TreatmentProvider } from './utils/laboratory';
import CopilotProvider from 'copilot-toolkit/CopilotProvider';

// @ts-expect-error Untyped dependency
import { FeedbackLoaderProvider } from 'feedback-loader/FeedbackLoaderProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResolvedAppContainer = withReferenceResolvers(AppContainer);
const client = new DataFetchingClient();
const apolloClient = createApolloClient();
export default class App {
  constructor() {
    this.store = configureStore();
  }
  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    const I18nProvider = createStandardI18nProvider();
    const langAvailable = initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    this.startRedux().then(result => {
      if (!result) {
        return null;
      }
      const {
        user,
        portal
      } = result;
      I18nProvider.setLocale({
        locale: user.locale,
        langEnabled: user.lang_enabled,
        timezone: portal && portal.timezone
      });
      return langAvailable.then(() => {
        this.store.dispatch(startAppAndFetch());
        this.startRouter();
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  startRedux() {
    const authReady = this.store.dispatch(getAuth());
    this.store.dispatch(fetchPreviewDomain());
    return authReady;
  }
  startRouter() {
    render( /*#__PURE__*/_jsx(FeedbackLoaderProvider, {
      children: /*#__PURE__*/_jsxs(Application, {
        name: "web-interactives-dashboard-ui",
        children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(ApolloProvider, {
          client: apolloClient,
          children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
            client: client,
            children: /*#__PURE__*/_jsx(MessageBusProvider, {
              children: /*#__PURE__*/_jsx(TreatmentProvider, {
                children: /*#__PURE__*/_jsx(ReduxProvider, {
                  store: this.store,
                  children: /*#__PURE__*/_jsx(CopilotProvider, {
                    children: /*#__PURE__*/_jsx(BrowserRouter, {
                      basename: getRootUrl(),
                      children: /*#__PURE__*/_jsx(Route, {
                        children: ({
                          history
                        }) => /*#__PURE__*/_jsx(RhumbProvider, {
                          config: rhumbConfig,
                          history: historyAdapter(history),
                          children: /*#__PURE__*/_jsx(ResolvedAppContainer, {})
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })]
      })
    }), {
      layoutType: 'sidebar'
    });
  }
}